<template>
    <div className="video-responsive">
       <iframe
         :width="width"
         :height="height"
         :src="src + '?title=0&byline=0&portrait=0&autoplay=1&autopause=0&loop=1&app_id=122963'"
         allowFullScreen
         title="Embedded Vimeo"
       />
     </div>
   </template>
   
   <script>
       export default {
           name:'VimeoApp',
           props: {
             width: Number,
             height:Number,
             src:String
           },
       }
   </script>

